import React from 'react';
import image1 from '../photos/1.jpg'
import image2 from '../photos/2.jpg'
import image3 from '../photos/3.jpg'
import image4 from '../photos/4.jpg'
import image5 from '../photos/5.jpg'
import image6 from '../photos/img6.jpg'
import me1 from '../photos/me1.jpg'
import SETSumGif from '../photos/SETSum.gif'

function Home(){
 return(
  <>
   <FirstSection />
   <WorkExperience />
   <ResearchSection />
   <ProjectSection />
  </>

 )
}

const FirstSection = () =>{
 return (
  <div className='fontBody container' style={{paddingTop: "15vh", paddingBottom: "3vh"}}>
    <h1>Yinuo "Eva" Hu</h1>
    <h3>Master of Analytics, IEOR | University of California, Berkeley</h3>
    <h3>Computer Science B.S. & Sociology | University of North Carolina at Chapel Hill</h3>
    {/* <h3>计算机 & 社会学 | 美国北卡大学教堂山分校</h3> */}
    <h3>evahuyn@berkeley.edu | eva.yinuohu@gmail.com</h3>
  </div>
 )
}

const WorkExperience = () => {
  return(
    <>
      <div className='middle-center' style={{paddingBottom: '3vh', paddingTop:'3vh', backgroundColor: 'rgb(133 122 122)', color:'white', paddingLeft: "3em", paddingRight: "3em"}}>
        <h2 className='fontPoppin' style={{fontSize: "3em", fontWeight: 'bold'}}>Work Experiences</h2>
        <p className='fontLibre' style={{fontSize: '1.5em'}}>Internship & Startup works</p>
      </div>

      <div style={{backgroundColor: '#f1f1f1', padding: '2em'}}>
        <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', marginBottom:"5vh"}}>
            <h3>AI Product Manager | xDRAFT Startup Initiative</h3>
            <div>
              <p>(May 2022 - Present)</p>
              <ul style={{paddingLeft:'3em'}}>
                <li>Created an AI-based email topic detector using PyTorch, Google APIs and Flask that allows users to organize high quantity
emails into subgroups, overseeing 3 data scientists and 2 SWEs</li>
                <li>Diagnosed and resolved data processing and data labeling challenges to improve the classification model accuracy by 30%</li>
                <li>Settled the B2B model for the company and defined the scope of the MVP after market research and competitor analysis</li>
              </ul>
            </div>
        </div>

        <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', marginBottom:"5vh"}}>
            <h3>Project Manager & Researcher | UNC NLP Group</h3>
            <div>
              <p>(Aug 2021 - Present)</p>
              <ul style={{paddingLeft:'3em'}}>
                <li>Created the pilot AI-based, personalized Student Evaluations of Teaching (SET) reports system to help instructors interpret SET results more efficiently and with less bias, and improved user satisfaction rating by 50%</li>
                <li>Developed the integrated AI modules using sentiment analysis, topic modeling, and extractive summarization, achieved SOTA model accuracies, and designed debiased algorithms to reduce bias by 40%</li>
                <li>Developed a web-based customer data platform prototype using SQL, JavaScript, Node JS, Express, and connected to Azure Cosmo DB.</li>
                <li>Built a visuzlied <a href="https://youtu.be/-Z2BBS7dvw0">web app</a> using React, Tableau, and D3.js, which will be used by over 13k instructors at the university</li>
              </ul>
            </div>
        </div>

        <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', marginBottom:"5vh"}}>
            <h3>Software Engineer & Researcher | UNC Education Technology Lab</h3>
            <div>
              <p>(Aug 2019 - Sep 2021)</p>
              <ul style={{paddingLeft:'3em'}}>
                <li>Led the web design team to build a lab <a href="http://ryoo-dept-soe.cloudapps.unc.edu/nsf/">website</a> from scratch using JavaScript, HTML & CSS to communicate lab outputs</li>
                <li>Conducted several independent research projects using video data from the lab to conduct qualitative analysis and semantic network analysis with R and KBDeX, and used Tableau and Gephi to visualize figures</li>
                <li>Published and presented research findings at EARLI 2021</li>
              </ul>
            </div>
        </div>

        <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', marginBottom:"5vh"}}>
            <h3>Technology Consultant Intern | Accenture</h3>
            <div>
              <p>(Mar 2021 - Jun 2021)</p>
              <ul style={{paddingLeft:'3em'}}>
                <li>Proposed cost-saving strategies by replacing costly Azure API calls with OpenCV services - reduced cost by around 10%, and created demos of MVP solutions for client’s digital transformation.</li>
                <li>Scrapped warehouse-related information of over 100 companies using Python, organized the results in excel sheets, and proposed and pitched IoT & digital twin solutions to 3+ clients</li>
                <li>Developed a web-based customer data platform prototype using SQL, JavaScript, Node JS, Express, and connected to Azure Cosmo DB.</li>
                <li>Analyzed unstructured data to draft industry reports on elevating AI solutions to promote sustainability in Chinese and global market separately and presented the reports to 10+ stakeholders</li>
                <li>Outlined product vision and actionable strategy for next generation remote working software in Avanade Innovation Contest and pitched the solution to 50+ employees</li>
              </ul>
            </div>
        </div>
      </div>
    </>
  )
}

const ProjectSection = () =>{
 return (
   <>
      <div className='middle-center' style={{paddingBottom: '3vh', paddingTop:'3vh', backgroundColor: 'rgb(82 82 82)', color:'white', paddingLeft: "3em", paddingRight: "3em"}}>
        <h2 className='fontPoppin' style={{fontSize: "3em", fontWeight: 'bold'}}>PROJECTS</h2>
        <p className='fontLibre' style={{fontSize: '1.5em'}}>Course Projects & Hackathon Projects</p>
      </div>

      <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', padding: '1em', marginBottom:"3vh", textAlign: "center"}}>
        <div className="row">
          <a href='http://fanzplay.herokuapp.com/' target='_blank'>
            <div className="col image6">
                <img src={image6} height="100%" width="100%" alt="focus6" className="image"/>
                <div className="overlay6">
                    <div className="text">
                      <h4>FanZPlay</h4>
                      <br />
                       <p>A responsive web app which allows sports fans to engage in a quiz game to claim awards</p>
                    </div>
                </div>
            </div>  
          </a>
          <a href='https://miaomiao-chat.herokuapp.com/' target='_blank'>
            <div className="col image1">
                    <img src={image1} height="100%" width="100%" alt="focus1" className="image"/>
                        <div className="overlay1">
                            <div className="text">
                              <h4>Miao Miao Social Networking Platform</h4>
                              <br />
                              <p>A revolutionary social media platform incorporated with interative games</p>
                            </div>
                        </div>
            </div>
          </a>

    </div>

  <div className="row">
          <a href='http://ryoo-dept-soe.cloudapps.unc.edu/nsf/' target='_blank'>
              <div className="col image2">
                  <img src={image2} height="100%" width="100%" alt="focus2" className="image"/>
                          <div className="overlay2">
                              <div className="text">
                                <h4>Making Science Visible Project Website</h4>
                                <br />
                                <p>The website to demonstrate the work of Making Science Visible Team</p>
                              </div>
                          </div>
              </div>
          </a>
    <a href='https://devpost.com/software/how-to-get-away-from-covid-19' target='_blank'>
                <div className="col image3">
                    <img src={image3} height="100%" width="100%" alt="focus3" className="image"/>
                    <div className="overlay3">
                        <div className="text">
                          <h4>Covid19 Toolkit</h4>
                          <br />
                          <p>A Covid-19 Toolkit which helps people of all ages learn facts and approaches to fight against Covid19</p>
                        </div>
                    </div>
                </div>        
            </a>

  </div>

  <div className="row">
  <a href='https://devpost.com/software/fridge-track' target='_blank'>
        <div className="col image4">
            <img src={image4} height="100%" width="100%" alt="focus4" className="image"/>
            <div className="overlay4">
                <div className="text">
                  <h4>System of Managing Food Expiration in Refrigerators</h4>
                  <br />
                  <p>A website which helps people to manage food storage in refrigerators and check the expiration data with bar code</p>
                </div>
            </div>
        </div>
    </a>
  <a href='https://github.com/Elnifio/TutorHub' target='_blank'>
      <div className="col image5">
          <img src={image5} height="100%" width="100%" alt="focus5" className="image"/>
          <div className="overlay5">
              <div className="text">
                  <h4>Platform for Activity Information Integration</h4>
                  <br />
                  <p>A platform which allows UNC students to explore event opportunities and keep track of events</p>
              </div>
          </div>
      </div>
    </a>

  </div>
  </div>
   </>

 )
}

const ResearchSection = () =>{
 return (
   <>
      <div className='middle-center' style={{paddingBottom: '3vh', paddingTop:'3vh', backgroundColor: '#e3dbd8', paddingLeft: "3em", paddingRight: "3em"}}>
        <h2 className='fontPoppin' style={{fontSize: "3em", fontWeight: 'bold'}}>RESEARCH</h2>
        <p className='fontLibre' style={{fontSize: '1.5em'}}>Aim to Elavate AI Tools and Data-driven Technology for Social Good</p>
      </div>

    <div style={{backgroundColor: '#f1f1f1', padding: '2em'}}>
        <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', marginBottom:"5vh"}}>
            <h3>SETSUM: Summarization and Visualization of Student Evaluations of Teaching (NAACL 2022 Demo)</h3>
            <div>
              <p>SETSum is an AI-based, interactive website which aims to summarize and visualize personalized Student Evaluations of Teaching (SETs) reports for university instructors. The system incorporates three Natural Language Processing Modules:</p>
              <ul style={{paddingLeft:'3em'}}>
                <li>Sentiment Analysis</li>
                <li>Aspect Extraction</li>
                <li>Aspect-based Summarization</li>
              </ul>
            </div>
            <a href='https://github.com/evahuyn/SETSum' target='_blank'>Github Repo</a><br />
            <a href='https://youtu.be/-Z2BBS7dvw0' target='_blank'>YouTube video to walk through the demo</a>
            <img src={SETSumGif} alt="loading..." style={{width: "80vw"}}/>
        </div>
      <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', marginBottom:"5vh"}}>
            <h3>Hateful Memes Detection</h3>
            <p>UNC COMP 590 - Course Project to Investigate Facebook <a href="https://hatefulmemeschallenge.com/">Hateful Memes Challenge</a> </p>
            <ul style={{paddingLeft:'3em'}}> 
              <li>Used <a href="https://arxiv.org/abs/1609.06647">Show and Tell</a> model to generate caption for memes</li>
              <li>Modified VisualBERT and ViLBERT models to incorporate the image caption as extra input</li>
              <li>The final models have enhanced performance with 3% - 4%</li>
            </ul>
            <a href='https://github.com/evahuyn/HateMemesDetection' target='_blank'>Github Repo</a>
        </div>

        <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', marginBottom:"5vh"}}>
            <h3>Understanding Linguistically Diverse Students’ Development of Vocabulary During Science Learning Using Semantic Network Analysis</h3>
            <p>This is an independent project based upon work supported by the National Science Foundation under Grant No. #1552114. 
              <br />
              Thanks to UNC Summer Undergraduate Research Award.</p>
            <a href='https://docs.google.com/presentation/d/1MtkKR2S5aMSIRrbQtKRJX6c6mSIL06vp/edit?usp=sharing&ouid=112109609718667628625&rtpof=true&sd=true' target='_blank'>Read More on Poster Demonstration</a>
        </div>
        
        <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', marginBottom:"5vh"}}>
            <h3>Analysis of How can Automated Feedback Engage Students in Developing and
      Explaining Models</h3>
            <p>The project aimed to analyze how automated feedback can help students in modeling activities.
              <br />
              Thanks to UNC Summer Research Intensive Course Award.</p>
            <a href='https://drive.google.com/file/d/1sfebirWy98ep-quyOvz11XW_dWKNOWte/view?usp=sharing' target='_blank'>Read More on Poster Demonstration</a>
        </div>

        <div className='container' style={{backgroundColor: 'rgb(255,255,255,0.6)', marginBottom:"5vh"}}>
            <h2 style={{textAlign: 'center'}}>Publications</h2><br />
            <div>
                <p><strong>Hu, Y.</strong>, Ryoo, K., & Tao, D. (2021). Scaffolding Collaborative Discourse and Modeling Practices. Poster presented at the <i>Biennial Conference of the European Association for Research on Learning and Instructions (EARLI 2021)</i>, online.</p>
                <p><strong>Hu, Y.</strong>, Zhang S., Sathy V., Panter A., Bansal M. (2022). SETSum: Summarization and Visualization of Student Evaluations of Teaching. Proceedings of the 2022 <i>Annual Conference of the North American Chapter of the Association for Computational Linguistics: Human Language Technologies: Demonstrations (NAACL 2022)</i> , Seattle, Washington.</p>
            </div>

        </div>

    </div>

   </>

  
 )
}

const PublicationSection = () =>{

}

export default Home;